const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
           <p>
              I'm a passionate game developer who brings ideas to life through code, creativity, and design. With a strong focus on gameplay mechanics and immersive experiences, I strive to craft engaging worlds. Whether solo or in a team, I love turning concepts into interactive, unforgettable adventures.
            </p>     
        </>
      ),
    },
  ],
  2: [
    {
      title: "2025 Bachelor's Degree",
      content: (
        <>
           <p>
              I hold a Bachelor's degree in Games Programming from the University of Derby, where I developed strong skills in C++, C#, Unity, and Unreal Engine. The course focused on real-time development, AI, physics, and software engineering, giving me hands-on experience with industry tools and collaborative game projects.
            </p>     
        </>
      ),
    },
  ],
  3: [
    {
      title: "2025 Front End Developer",
      content: (
        <>
           <p>
              I currently work at eLearning Industry as a Front-End Developer and Software Engineer. I specialize in building responsive, user-friendly interfaces using modern web technologies. My role involves collaborating with designers and backend teams to deliver high-quality eLearning platforms that enhance user experience and support effective digital education solutions.
            </p>     
        </>
      ),
    },
    {
      title: "2018-2025 Game Developer",
      content: (
        <>
           <p>
              I’m the founder of OHESTIS GAMES, where I lead game development and bring original ideas to life. Using Unity, C#, and creative design, I build immersive gameplay experiences from the ground up—handling programming, mechanics, visuals, and sound to deliver polished, engaging projects driven by passion and innovation.
            </p>     
        </>
      ),
    },
  ],
};

export default subheadingsData;